import React from 'react';

function Music() {
  return (
    <section id="music">
      <h2>Music</h2>
      <iframe title='Spotify Embedded' 
      style={{borderRadius: "12px"}} 
      src="https://open.spotify.com/embed/artist/4rTWBToWooAmfwG8VFdqJn?utm_source=generator" 
      width="100%" 
      height="500" frameBorder="0" 
      allowFullScreen="" 
      allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" 
      loading="lazy">
      </iframe>
    </section>
  );
}

export default Music;
